import { defineComponent as _defineComponent } from 'vue';
import { useSlots, ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import EnDialog from 'Components/base/EnDialog/EnDialog.vue';
import EnDeleteDialog from 'Components/modals/EnDeleteDialog/EnDeleteDialog.vue';
import EnFilterBar from '../slots/EnFilterBar.vue';
import { EnButton } from '../../base/EnButton';
import EnDataGridShortcutFilterBar from '../filters/EnDataGridShortcutFilterBar.vue';
import EnAddressSearchFilterButton from '../filterButtons/EnAddressSearchFilterButton.vue';
import EnDateFilterButton from '../filterButtons/EnDateFilterButton.vue';
import EnSearchFilterButton from '../filterButtons/EnSearchFilterButton.vue';
import EnAutocompleteFilterButton from '../filterButtons/EnAutocompleteFilterButton.vue';
import EnFilterButton from '../filterButtons/EnFilterButton.vue';
import EnMultipleSearchFilterButton from '../filterButtons/EnMultipleSearchFilterButton.vue';
import EnNumberFilterButton from '../filterButtons/EnNumberFilterButton.vue';
import { FilterButtonType } from 'Components/datagrid/types/filterButtonType';
import { EnBanner } from 'Components/alert/EnBanner';
import { EnForm } from 'Components/inputs/EnForm';
export default /*@__PURE__*/ _defineComponent({
    __name: 'EnDatagridTopPanel',
    props: {
        allowAdding: Boolean,
        allowDeleting: Boolean,
        dense: Boolean,
        showEditDialog: Boolean,
        fixedActions: Boolean,
        editFormIsInvalid: Boolean,
        addingDialogIsVisible: Boolean,
        showDeleteDialog: Boolean,
        showFilterBar: Boolean,
        showFilterOptions: Boolean,
        showColumnsButton: {
            type: Boolean,
            default: true,
        },
        showActionButton: {
            type: Boolean,
            default: true,
        },
        showResetFilterButton: Boolean,
        showExportButton: Boolean,
        dialogSaveButtonText: String,
        editDialogErrorMessage: String,
        editDialogTitleComputed: String,
        columns: Array,
        filterButtons: {
            default: [],
            type: (Array)
        },
        shortcutFilterButtons: {
            default: [],
            type: (Array)
        },
        editDialogOptions: Object,
        addItem: Function,
        closeEditDialog: Function,
        saveItem: Function,
        deleteItemConfirm: Function,
        resetFilters: Function,
        resetIndividualFilter: Function,
        restoreDefaultView: Function,
        /**
         * If false, there is nothing to restore and the button is hidden.
         */
        showRestoreDefaultViewButton: Boolean,
        reorderColumns: Function,
        exportData: Function,
        exportAllData: Function,
        /**
         * Key used to identify items.
         */
        dataGridKey: [String, Array],
        /**
         * Shows number of filtered elements
         */
        totalCount: Number,
        filters: Object
    },
    emits: ['update:showEditDialog', 'update:showDeleteDialog', 'colums-show-all', 'column-hidden', 'filter-updated', 'reset-filter', 'columns-show-all'],
    setup(__props, { expose: __expose, emit: __emit }) {
        const { t } = useI18n();
        const slots = useSlots();
        /**
         * A simple bar to place filter buttons in. Mainly used for EnDataGrid.
         */
        const props = __props;
        const editDialogForm = ref();
        const validationErrorRef = ref();
        const filterBarContent = ref();
        const filterBarRef = ref();
        const emit = __emit;
        const showEditDialogComputed = computed({
            get() {
                return props.showEditDialog;
            },
            set(value) {
                emit('update:showEditDialog', value);
            },
        });
        const showDeleteDialogComputed = computed({
            get() {
                return props.showDeleteDialog;
            },
            set(value) {
                emit('update:showDeleteDialog', value);
            },
        });
        function showAllColumns() {
            emit('columns-show-all');
        }
        function handleResetFilters() {
            props.filterButtons.forEach((fb) => fb.visible = false);
            props.resetFilters?.();
        }
        async function toggleVisibilityColumn(column) {
            emit('column-hidden', column.value);
        }
        const editFormIsDisabledComputed = computed(() => {
            return props.editFormIsInvalid || !editDialogForm.value?.isValid;
        });
        /**
         * show divider only if at least one filter button is visible
         */
        const isDividerVisible = computed(() => {
            return props.filterButtons.filter(fb => fb.visible).length > 0;
        });
        const filterBarIsVisible = computed(() => {
            return props.showFilterBar || props.showExportButton || (props.allowAdding && !props.dense);
        });
        const hasFilterButtons = computed(() => {
            return props.filterButtons.length > 0;
        });
        const hasGapToTable = computed(() => {
            return filterBarIsVisible.value || hasFilterButtons.value || !!slots.filter;
        });
        function updateFilter(newVal, filter) {
            emit('filter-updated', newVal, filter);
        }
        __expose({
            editDialogForm,
            filterBarContent,
            filterBarRef,
            validationErrorRef,
        });
        const __returned__ = { t, slots, props, editDialogForm, validationErrorRef, filterBarContent, filterBarRef, emit, showEditDialogComputed, showDeleteDialogComputed, showAllColumns, handleResetFilters, toggleVisibilityColumn, editFormIsDisabledComputed, isDividerVisible, filterBarIsVisible, hasFilterButtons, hasGapToTable, updateFilter, EnDialog, EnDeleteDialog, EnFilterBar, get EnButton() { return EnButton; }, EnDataGridShortcutFilterBar, EnAddressSearchFilterButton, EnDateFilterButton, EnSearchFilterButton, EnAutocompleteFilterButton, EnFilterButton, EnMultipleSearchFilterButton, EnNumberFilterButton, get FilterButtonType() { return FilterButtonType; }, get EnBanner() { return EnBanner; }, get EnForm() { return EnForm; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
